module.exports = __webpack_public_path__ + "static/media/Artboard16.37ccec15.png";